// this is ES6 syntax, it's essentially equivalent to: var React =
// require('react')
import React from 'react';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
  }

  //now this component is getting passed props from the AppContainer
  static propTypes = {
    config: React.PropTypes.object,
    location: React.PropTypes.object,
  };

  isActive(route) {
    return this.props.location.pathname.indexOf(route) != -1;
  }

  render() {
    const heroImage = '/static/dist/img/app-hero.jpg';

    return (
      <div id="employment-application-page">
        {/* TODO - Get the url for the selected theatre */}
        <img className="img-responsive d-none d-sm-block" src={heroImage} />{' '}
        {!this.isActive('confirmation') ? (
          <div className="container">
            <h1 id="application-title">Employment Application</h1>
            <ul className="nav nav-tabs d-none d-md-flex">
              <li className={this.isActive('personal-information') ? 'active' : ''}>
                <a href="#/personal-information">Personal Information</a>
              </li>
              <li className={this.isActive('employment-desired') ? 'active' : ''}>
                <a href="#/employment-desired">Employment/Availability</a>
              </li>
              <li className={this.isActive('education') ? 'active' : ''}>
                <a href="#/education">Education</a>
              </li>
              <li className={this.isActive('employment-history') ? 'active' : ''}>
                <a href="#/employment-history">Work History</a>
              </li>
              <li className={this.isActive('complete') ? 'active' : ''}>
                <a href="#/complete">Complete</a>
              </li>
            </ul>
            {this.props.children}
          </div>
        ) : (
          <div className="container">{this.props.children}</div>
        )}
      </div>
    );
  }
}
